import Headers from "../../../config/paymentConfig/headers";
import ApiCalls from "../../../config/paymentConfig/apiCalls";
import LocalStorageFunc from "../../../helpers/paymentHelpers/localStorageFunc";
import savedCardsDummyData from "../../../assets/paymentAssets/FallbackData/savedCards.json";
import cmsPaymentData from "../../../assets/paymentAssets/FallbackData/cmsPaymentData.json";
import recommendedPaymentMethod from '../../../assets/paymentAssets/FallbackData/recomendedPaymentMethod.json';
import otherPaymentDataJson from '../../../assets/paymentAssets/FallbackData/otherPaymentData.json';
import Utility from "../../../helpers/paymentHelpers/utility";
import { keyMapsAction, keyMapsMutation } from "../../../helpers/paymentHelpers/storeKeys";
import { get } from "lodash";
import {
	common, PAYMENT_METHOD
} from "../../../helpers/paymentHelpers/paymentConstants";

export default {
	namespaced: true,
	state: {
		paymentModulesData: [],
		isOtherPaymentLoaded: false,
		otherPaymentData: [],
		cmsOtherPaymentsData: cmsPaymentData,
		isRecommendedPaymentLoaded: false,
		recommendedPaymentData: [],
		isSavedPaymentLoaded: false,
		savedPaymentData: [],
		allPaymentDataLoaded: false,
		isAddCreditDebitCardModal: false,
		currentSelectedPaymentMethod: {},
		binOfferSavedPaymentData: [],
		isSaveCardBankModalOpen: false,
		recommendedVisibleItems: 3,
		savedCardVisibleItems: 3
	},
	getters: {},
	mutations: {
		updateSaveCardBankModal(state, payload) {
			state.isSaveCardBankModalOpen = payload;
			payload ? document.body.classList.add("body-stop-scroll-mobile") :
				document.body.classList.remove("body-stop-scroll-mobile");
		},
		updateBinOfferSavedPaymentData(state, payload) {
			state.binOfferSavedPaymentData = payload;
		},
		updateSaveCardVisibleData(state, payload) {
			state.savedCardVisibleItems = payload;
		},
		updateAddCreditDebitCardModal(state, payload) {
			state.isAddCreditDebitCardModal = payload;
			payload ? document.body.classList.add("body-stop-scroll-mobile") :
			document.body.classList.remove("body-stop-scroll-mobile");
		},
		updateOtherPaymentLoader(state, payload) {
			state.isOtherPaymentLoaded = payload;
		},
		updateOtherPaymentResponse(state, payload) {
			state.otherPaymentData = payload;
		},
		updateCmsOtherPaymentsData(state, payload) {
			state.cmsOtherPaymentsData = payload;
		},
		updateRecommendedPaymentLoader(state, payload) {
			state.isRecommendedPaymentLoaded = payload;
		},
		updateRecommendedPaymentResponse(state, payload) {
			state.recommendedPaymentData = payload;
		},
		updateSavedPaymentLoader(state, payload) {
			state.isSavedPaymentLoaded = payload;
		},
		updateSavedPaymentResponse(state, payload) {
			state.savedPaymentData = payload;
		},

		updatePaymentModulesData(state, payload) {
			let tempObj = [];
			tempObj.push(...state.paymentModulesData, { name: payload.name, position: payload.position })
			// tempObj["position" + payload.position] = payload.name;
			state.paymentModulesData = tempObj
			// state.paymentModulesData["position" + payload.position] = payload.name;
		},
		updatePaymentsModeLoader(state, payload) {
			state.allPaymentDataLoaded = payload;
		},
		updateCurrentPaymentObject(state, payload) {
			state.currentSelectedPaymentMethod = payload;
		},
		updateRecommendedVisibleItems(state, payload) {
			state.recommendedVisibleItems = payload;
		},
		updateMainScreenForNB(state, payload) {
			if (Object.keys(payload).length > 0) {
				state.otherPaymentData.map(i => {
					if (i.paymentMode == "NB") {
						let checkItemAlreadyPresentInVisible = i.visibleData?.findIndex(j => {
							return j.paymentId == payload.paymentId
						})
						if (checkItemAlreadyPresentInVisible !== -1) {
							//item is already present in visible data so no need to push from modal data to visible data
						} else {
							i.visibleData.unshift(payload || {})
							i.visibleData.pop();
						}
					}
				})
			}
		},
		updateMainScreenForSavedPayment(state, payload) {
			if (Object.keys(payload).length > 0) {
				let removeCurrentSelectBank = state.savedPaymentData.filter(i => i.cardNumber !== payload.cardNumber)
				removeCurrentSelectBank.unshift(payload || {})
				state.savedPaymentData = removeCurrentSelectBank || [];
			}
		},
		updateMainScreenForWallet(state, payload) {
			if (Object.keys(payload).length > 0) {
				state.otherPaymentData.map(i => {
					if (i.paymentMode == "CASHCRD") {
						let checkItemAlreadyPresentInVisible = i.visibleData?.findIndex(j => {
							return j.paymentId == payload.paymentId
						})
						if (checkItemAlreadyPresentInVisible !== -1) {
							//item is already present in visible data so no need to push from modal data to visible data
						} else {
							i.visibleData.unshift(payload || {})
							i.visibleData.pop();
						}
					}
				})
			}
		}
	},
	actions: {
		paymentPageCommonAction({ commit, state }, payload) {
			try {
				commit("updatePaymentModulesData", payload);
			} catch (err) {
				console.log('ERROR in PAYMENT PAGE COMMON ACTION', err);
			} finally {
				// console.log('finally in PAYMENT PAGE COMMON ACTION');
			}
		},
		getOtherPaymentApi({ commit, state, rootState }, payload) {
			try {
				const tipCartVariant = Utility.getSessionStorageValue('VWO_TIPCART_VARIANT');
				Promise.all([
					ApiCalls.RECOMMENDED_PAYMENT_OPTION_API({
						headers: Headers(),
						payload: { 'visible_count': state.recommendedVisibleItems || 5 },
					}),
					ApiCalls.GET_SAVED_CARDS_API({
						headers: Headers({ mid: true, xTenantID: true }),
						payload: {},
					}),
					ApiCalls.OTHER_PAYMENT_OPTION_API({
						headers: {
							...Headers(),
							tip_variant: tipCartVariant || 'NA'
						},
						payload: {},
					})
				])
				.then(async ([recommendedData, savedData, otherData]) => {
					let customSavedData = []
					if (savedData?.data?.cards?.length > 0) {
						customSavedData = savedData?.data?.cards?.map(i => {
							return {
								...i, paymentMode: "CC", paymentId: "CC"
							}
						}) || []
					}

					// start FOR CV
					let custmOtherData = otherData?.data || otherPaymentDataJson;
					let deliveryType = rootState.Address.deliveryType || "D";
					const deliveryInstructionResponse = Utility.zeroContactSelector(deliveryType, rootState.Global.appConfig)

					const zeroContactDelivery = LocalStorageFunc.getZeroContactDelivery() || false;
					if (
						zeroContactDelivery &&
						(deliveryInstructionResponse.disabledCOD ||
							deliveryInstructionResponse.disabledEGV)
					) {
						custmOtherData.payment.forEach(payment => {
							if (
								payment.paymentMode === PAYMENT_METHOD.CASH &&
								deliveryInstructionResponse.disabledCOD
							) {
								payment.status = 'D';
							}
							if (
								payment.paymentMode === PAYMENT_METHOD.EVOUCHER &&
								deliveryInstructionResponse.disabledEGV
							) {
								payment.status = 'D';
							}
						});
					}

					const allData = {
						recommendedPayment: {
							name: "recommendedPayment",
							data: recommendedData.data?.recommendedPayOptions ? recommendedData.data.recommendedPayOptions : []
							// data: Utility.preprocessRecommendedData(recommendedData.data?.recommendedPayOptions ? recommendedData.data.recommendedPayOptions : [], state.recommendedVisibleItems)
							// data: Utility.preprocessRecommendedData(recommendedPaymentMethod, state.recommendedVisibleItems)
						},
						savedPayment: {
							name: "savedPayment",
							data: savedData.data ? customSavedData :  []
							// data: savedCardsDummyData

						},
						otherPayment: {
							name: "otherPayment",
							data: custmOtherData
						}
					}

					const removeByPaymentId = (arr, paymentId) => {
						const requiredIndex = arr?.findIndex(e1 => {
							return e1.paymentId?.toLowerCase() === String(paymentId).toLowerCase();
						});
						if (requiredIndex === -1) {
							return false;
						};
						return !!arr?.splice(requiredIndex, 1);
					}

					const removeByCardId = (arr, cardId) => {
						const requiredIndex = arr?.findIndex(e1 => {
							return e1.cardId === String(cardId);
						});
						if (requiredIndex === -1) {
							return false;
						}
						return !!arr?.splice(requiredIndex, 1);
					}

					const getIndex = (arr, paymentMode) => {
						return arr?.findIndex(e1 => {
							return e1.paymentMode.toLowerCase() === String(paymentMode).toLowerCase();
						});
					}

					const topmostPaymentOption =
						state.paymentModulesData[0]?.name ?
							state.paymentModulesData[0].name :
							'recommendedPayment';
					const secondMostPaymentOption =
						state.paymentModulesData[1]?.name ?
							state.paymentModulesData[1].name :
							'savedPayment';

					let tempRecommendedArr = allData.recommendedPayment.data || [];
					if (topmostPaymentOption === 'recommendedPayment') {
						tempRecommendedArr.forEach(element => {
							const paymentMode = element.paymentMode;
							if (paymentMode === 'WALLET') {
								const index = getIndex(allData.otherPayment.data.payment, paymentMode);
								if(index >= 0) {
									removeByPaymentId(allData.otherPayment.data.payment[index].subOptions, element.paymentId);
								}
								// special handling for paytm wallet - beacuse it's paymentMode is CASHCRD in otherPayments data
								if (element.paymentId == 'PAYTM_WALLET') {
									const index1 = getIndex(allData.otherPayment.data.payment, 'CASHCRD')
									if(index1 >= 0) {
										removeByPaymentId(allData.otherPayment.data.payment[index1].subOptions, element.paymentId);
									}
								}
							}
							else if (paymentMode === 'NB') {
								const index = getIndex(allData.otherPayment.data.payment, paymentMode);
								if(index >= 0) {
									allData.otherPayment.data.payment[index]?.subOptions?.forEach(ele => {
										removeByPaymentId(ele.subOptions, element.paymentId);
									})
								}
							}
							else if (paymentMode === 'CASHCRD') {
								const index = getIndex(allData.otherPayment.data.payment, paymentMode);
								if(index >= 0) {
									removeByPaymentId(allData.otherPayment.data.payment[index].subOptions, element.paymentId);
								}
							}
							else {
								removeByPaymentId(allData.otherPayment.data.payment, element.paymentId);
							}
						});
					}
					else if (topmostPaymentOption === 'savedPayment') {
						if (secondMostPaymentOption == "recommendedPayment") {
							tempRecommendedArr.forEach(element => {
								//remove from otherPayment
								const paymentMode = element.paymentMode;
								if (paymentMode === 'WALLET') {
									const index = getIndex(allData.otherPayment.data.payment, paymentMode);
									if(index >= 0) {
										removeByPaymentId(allData.otherPayment.data.payment[index].subOptions, element.paymentId);
									}
									// special handling for paytm wallet - beacuse it's paymentMode is CASHCRD in otherPayments data
									if (element.paymentId == 'PAYTM_WALLET') {
										const index1 = getIndex(allData.otherPayment.data.payment, 'CASHCRD');
										if(index1 >= 0) {
											removeByPaymentId(allData.otherPayment.data.payment[index1].subOptions, element.paymentId);
										}
									}
								}
								else if (paymentMode === 'NB') {
									const index = getIndex(allData.otherPayment.data.payment, paymentMode);
									if(index >= 0) {
										allData.otherPayment.data.payment[index].subOptions?.forEach(ele => {
											removeByPaymentId(ele.subOptions, element.paymentId);
										})
									}
								}
								else if (paymentMode === 'CASHCRD') {
									const index = getIndex(allData.otherPayment.data.payment, paymentMode);
									if(index >= 0) {
										removeByPaymentId(allData.otherPayment.data.payment[index].subOptions, element.paymentId);
									}
								}
								else {
									removeByPaymentId(allData.otherPayment.data.payment, element.paymentId);
								}
							});
						} else {
							let rData = [];
							tempRecommendedArr?.forEach(element => {
								// remove every element with label key
								if (element.cardId) {
									rData.push(element)
								}
							});
							tempRecommendedArr = rData;
						}
					}
					else if (topmostPaymentOption === 'otherPayment') {
						let rData = [];
						tempRecommendedArr?.forEach(element => {
							// remove every element with label key
							if (element.cardId) {
								rData.push(element)
							}
						});
						tempRecommendedArr = rData;
						if (secondMostPaymentOption == "recommendedPayment") {
							tempRecommendedArr?.forEach(element => {
								//remove from savedCards
								if (element.cardId) {
									removeByCardId(allData.savedPayment.data, element.cardId);
								}
							});
						} else {
							allData.savedPayment?.data.forEach(element => {
								if (element.cardId) {
									removeByCardId(tempRecommendedArr, element.cardId);
								}
							})
						}
					}

					let customSavedCardData = [];
					// <-- In case of payment mode comes as SAVECARD we have push the particular bank into top in visible data >
					let localStorPaymtMode = LocalStorageFunc.getPaymentOfferMode();
					let tempModePayment = rootState.PaymentSubmit.paymentModeTemp;
					let cardIdPaymentMode = tempModePayment?.cardId ? tempModePayment : localStorPaymtMode;
					if ((cardIdPaymentMode?.cardType == "CC") || (cardIdPaymentMode?.cardType == "DC") && cardIdPaymentMode?.cardId && (payload.origin != 'applyPromo')) {
						let isItemExistInDataForCard = allData.savedPayment.data.findIndex(i => i.cardNumber == cardIdPaymentMode.cardNumber)
						if (isItemExistInDataForCard !== -1) {
							if ((allData.savedPayment.data?.length !== undefined) && (allData.savedPayment.data?.length > 0)) {
								let removeCurrentSelectBank = allData.savedPayment.data?.filter(i => {
									return i.cardNumber !== cardIdPaymentMode.cardNumber
								})

								// when save card item from local storage is not present in save card api data 
								// then we have to show the place order footer to be not working
								if (removeCurrentSelectBank.length == allData.savedPayment.data.length) {
									commit("PaymentSubmit/updatePaymentMode", {}, { root: true });
									commit(keyMapsMutation.UPDATE_PAYMENT_MODE_TEMP, {}, { root: true });
									commit(keyMapsMutation.UPDATE_IS_PLACE_ORDER_ACTIVE, false, { root: true });
								}

								removeCurrentSelectBank.unshift(cardIdPaymentMode || {})
								customSavedCardData = removeCurrentSelectBank.map(i => {
									return {
										...i, paymentMode: i.cardType, paymentId: i.cardType
									}
								}) || [];
							}
						} else {
							//card don't exist in saved card data
							customSavedCardData = allData.savedPayment.data || []
							commit("PaymentSubmit/updatePaymentMode", {}, { root: true });
							commit(keyMapsMutation.UPDATE_PAYMENT_MODE_TEMP, {}, { root: true });
							commit(keyMapsMutation.UPDATE_IS_PLACE_ORDER_ACTIVE, false, { root: true });
							// LocalStorageFunc.setPaymentMode({});
						}
					} else {
						customSavedCardData = allData.savedPayment.data || []
					}
					// 
					commit("updateRecommendedPaymentResponse", tempRecommendedArr);
					commit("updateRecommendedPaymentLoader", true);
					//
					commit("updateSavedPaymentResponse", customSavedCardData || []);
					commit("updateSavedPaymentLoader", true);

					// Deep copy of other data
					const copyofOtherData = Utility.deepCopyArry(allData.otherPayment.data) || [];

					state.cmsOtherPaymentsData.forEach((ele, ind) => {
						const paymentMode = ele.paymentMode
						if (paymentMode === 'WALLET') {
							let otherData = copyofOtherData.payment?.find(i => i.paymentMode == 'WALLET') || {};
							ele['visibleData'] = ele.visible_items < Object.keys(otherData.subOptions).length ? otherData.subOptions?.slice(0, ele.visible_items) : otherData?.subOptions;
							ele['data'] = otherData.subOptions || [];
							ele['currentIndex'] = ind;
						} else {
							const otherData = copyofOtherData.payment || [];
							if (paymentMode === 'NB') {
								const index = getIndex(otherData, paymentMode);
								if(index >= 0) {
									ele['visibleData'] = ele.visible_items < otherData[index]?.subOptions[0]?.subOptions?.length ? otherData[index]?.subOptions[0]?.subOptions?.slice(0, ele.visible_items) : otherData[index]?.subOptions[0]?.subOptions;
									ele['data'] = otherData[index]?.subOptions;
									ele['currentIndex'] = ind;
									// <-- In case of payment mode comes as NB we have push the particular bank into top in visible data >
									if (localStorPaymtMode?.paymentMode == "NB") {
										let isItemExistInDataForNB = ele.data.findIndex(i => i.paymentId == localStorPaymtMode.paymentId)
										let isItemAvailInVisibleData = ele.visibleData?.findIndex(i => i.paymentId == localStorPaymtMode.paymentId) || [];
										if (isItemExistInDataForNB !== -1) {
											if (isItemAvailInVisibleData !== -1) {
												//Data is exist in visible data
											} else {
												ele.visibleData.unshift(localStorPaymtMode)
												ele.visibleData.pop()
											}
										}
									}
								}
							}
							else if (paymentMode === 'CASHCRD') {
								ele.data = [];
								ele.visibleData = [];
								ele['currentIndex'] = ind;
								const index = getIndex(otherData, paymentMode);
								if(index >= 0) {
									let otherDataArr = otherData[index]?.subOptions || [];
									//Push Paytm object at index 0 in data
									// let customPaytmLinkIsAvail = otherDataArr.find(j => j.paymentId == "PAYTM_WALLET");
									// if(customPaytmLinkIsAvail) {
									// 	otherDataArr = otherDataArr.filter(i => i.paymentId !== "PAYTM_WALLET");
									// 	otherDataArr.unshift(customPaytmLinkIsAvail);
									// }

									if (ele.visible_items < otherDataArr.length) {
										ele.visibleData.push(...otherDataArr.slice(0, ele.visible_items));
									} else {
										ele.visibleData.push(...otherDataArr);
									}
									ele.data.push(...otherDataArr);
									// <-- In case of payment mode comes as CASHCRD we have push the particular bank into top in visible data >
									if (localStorPaymtMode?.paymentMode == "CASHCRD") {
										let isItemExistInDataForWallet = ele.data.findIndex(i => i.paymentId == localStorPaymtMode.paymentId)
										let isItemAvailInVisibleData = ele.visibleData?.findIndex(i => i.paymentId == localStorPaymtMode.paymentId) || -1;
										if (isItemExistInDataForWallet !== -1) {
											if (isItemAvailInVisibleData !== -1) {
												console.log("Data is exist in visible data")
											} else {
												let cstmData = ele.visibleData.filter(i => i.paymentId !== localStorPaymtMode.paymentId)
												cstmData.unshift(localStorPaymtMode)
												if (cstmData.length > 4) {
													cstmData.pop()
												}
												ele.visibleData = cstmData;
											}
										}
									}
								}
							} else {
								const index = getIndex(otherData, paymentMode);
								ele.data = [];
								ele.visibleData = [];
								ele['currentIndex'] = ind;
								if (index >= 0) {
									ele.data.push(otherData[index]);
									ele.visibleData.push(otherData[index]);
								}
							}
						}
						const isWalletUsed = LocalStorageFunc.getIsWalletUsed();
						const { hidePaymentMethodsForWallet = [] } = rootState?.Global.appConfig?.config
						if (isWalletUsed && (hidePaymentMethodsForWallet.length > 0)) {
							const check = hidePaymentMethodsForWallet.includes(paymentMode);
							if (check) {
								state.cmsOtherPaymentsData = state.cmsOtherPaymentsData.filter(i => i.paymentMode !== paymentMode)
							}
						}
					});
					commit("updateOtherPaymentResponse", state.cmsOtherPaymentsData);
					commit("updateOtherPaymentLoader", true);
				})
				.catch((errors) => {
					console.log('ERROR IN ALL OR ONE...', errors);
				})
			} catch (err) {
				console.log('ERROR in OTHER PAYMENT OPTIONS', err);
			} finally {
				// console.log('finally in OTHER PAYMENT OPTIONS');
				commit("updatePaymentsModeLoader", true);
				setTimeout(() => {
					// shimmer for savedpayment apply offer button promo code
					commit("ErrorModal/updateApplyOfferShim", {code: "", payload: false}, {root: true})
				}, 700);
			}
		},
		getPaytmWalletBalance({ commit, state, dispatch }, payload) {
			try {
				ApiCalls.PAYTM_WALLET_BALANCE_API({
					headers: Headers(),
					payload: {
						orderTransactionId: payload.orderTransactionId,
						mobile: payload.mobile,
						consultBalance: payload.consultBalance
					},
				})
					.then(function (response) {
						if (response?.data) {
							const paytmRes = response.data;
							if (paytmRes.body) {
								if (paytmRes.body.resultInfo && paytmRes.body.resultInfo.resultStatus == "SUCCESS") {
									commit(keyMapsMutation.UPDATE_SHOW_LINK_PAYTM_WALLET, false, { root: true });
									const walletObj = get(paytmRes, 'body.payOptions[0]', {});
									commit("PaytmWallet/updatePaytmLinkResponseData", walletObj, { root: true });
								}
							}
						}
					})
					.catch(function (error) {
						console.log('ERROR in PAYTM WALLET BALANCE...', error);
					});
			} catch (err) {
				console.log('ERROR in PAYTM WALLET BALANCE', err);
			}
		},
		binOfferSavePaymentApi({ state, commit, dispatch }, payload) {
			ApiCalls.GET_SAVED_CARDS_API({
				headers: Headers({ mid: true, xTenantID: true }),
				payload: { PROMOCODE: get(payload, 'explicitPromo.promoCode', "") },
			})
				.then(res => {
					if (res?.data?.status == "SUCCESS" && res?.data?.cards?.length > 0) {
						let custm = res?.data?.cards?.map(i => {
							return {
								...i, paymentMode: "CC", paymentId: "CC"
							}
						}) || []
						commit(keyMapsMutation.UDPATE_BIN_TEXT, "WITHOUT_BIN", { root: true });
						commit("updateBinOfferSavedPaymentData", custm)
						commit("PaymentSubmit/updatePaymentModeTemp", custm[0], { root: true }); // WHEN WE HAVE APPLIED THEN WE WILL SET THE FIRST ITEM AS SELECTED
					} else {
						// for updating empty add new card custom payment mode
						if ((get(payload, 'explicitPromo.paymentOptions', []).length > 0)) {
							const { label, subLabel, imgUrl, paymentId } = get(payload, 'explicitPromo.paymentOptions', [])[0] || {};
							let customNoCardObj = {
								name: "CC",
								index: 1,
								label: subLabel || label || "",
								paymentId: paymentId || "CC",
								status: "E",
								paymentMode: paymentId || "CC",
								img_url: imgUrl || "",
							};
							// if( this.binOfferCardDataDisplay.length > 0){
							//   customNoCardObj = this.binOfferCardDataDisplay[0] || {};
							// }
							if (customNoCardObj?.cardId !== undefined && customNoCardObj?.cardId) {
								commit(keyMapsMutation.UPDATE_PAYMENT_MODE_TEMP, { ...customNoCardObj, paymentId: "CC", paymentMode: "CC" }, { root: true });
							} else {
								commit(keyMapsMutation.UPDATE_PAYMENT_MODE_TEMP, customNoCardObj, { root: true });
							}
							commit(keyMapsMutation.UPDATE_IS_PLACE_ORDER_ACTIVE, true, { root: true });
							dispatch(keyMapsAction.SET_PAYMENT_MODE_TEMP_ACTION, customNoCardObj, { root: true });
						}
					}
					commit("PriceDetail/updateCartDataLoaded", true, { root: true });

				}).catch(err => console.log(err))
		},
		addCardInFirstPlaceIncaseOfBinForSaveCard({state, commit, dispatch, rootState}, payload){
      const { cardNumber = "" } = rootState.PaymentSubmit.paymentModeTemp || {}
      if(cardNumber.length > 0){ // for setting item to first when user click on apply offer in case of savepayment 
        let removeCurrentSelectBank = state.savedPaymentData?.filter(i => {
          return i.cardNumber !== cardNumber
        }) || []
        if(cardNumber.length > 0) {
          removeCurrentSelectBank.unshift(rootState.PaymentSubmit.paymentModeTemp || {})
          state.savedPaymentData = removeCurrentSelectBank
        }
      }
		}
	},
};
